<div class="redirect-auth-container">
  <router-outlet></router-outlet>
</div>
